import React, { useState, useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";
import { AdminSideBarMenuData } from "content/Sidebar";
import { AsidebarStore } from "(store)/AsidebarStore";
import { MainPageLoader } from "components/loaders";
import { useAuthStore } from "(store)/useAuthStore";
import * as Components from "components";
import { getProfile } from "services/admin.service";
import { useUserStore } from "(store)/useUserStore";
import Socket from "services/socket";

const Home = () => {
  const token = localStorage.getItem("token");
  // States
  const [isLoading, setIsLoading] = useState(true);
  const [isParallelLoading, setIsParallelLoading] = useState(true);
  const setSideBarOptions = AsidebarStore((state) => state.setSideBarOptions);
  const location = useLocation();
  const setToken = useAuthStore((state) => state.setToken);
  const { userInfo, setUser } = useUserStore();
  const navigate = useNavigate();
  const socket = Socket();

  useEffect(() => {
    getProfile()
      .then((res) => {
        if (res?.status === 200) {
          const { data } = res.data;
          if (data) {
            setUser(data);
            setIsLoading(false);
            setIsParallelLoading(false);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });

    socket.emit("adminOnline", { token: token, userType: "admin" });
  }, []);

  // Handle scroll to top on navigation
  useEffect(() => {
    const scrollableContainer = document.getElementById("scrollable-container");
    if (scrollableContainer) {
      scrollableContainer.scrollTo(0, 0);
    }
  }, [location.pathname]);

  useEffect(() => {
    setSideBarOptions(AdminSideBarMenuData);
  }, [setSideBarOptions]);

  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      setToken(token);
    }
  }, []);

  return (
    <>
      {isLoading || isParallelLoading ? (
        <div className="w-full h-screen flex justify-center items-center">
          <MainPageLoader />
        </div>
      ) : (
        <div className="flex h-screen">
          <Components.Sidebar />
          <div className="flex-1 flex flex-col min-w-[1%]">
            <Components.Menubar />
            <div className="flex-1 flex flex-col h-[calc(100%-80px)]">
              <div
                id="scrollable-container"
                className="w-full h-full overflow-y-auto"
              >
                <div className="min-h-full flex flex-col justify-between w-full dark:bg-[#1f1f1f]">
                  <Outlet />
                  <Components.Footer />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Home;
